import { render, staticRenderFns } from "./WeeklyUpdates.vue?vue&type=template&id=256a29ae&"
import script from "./WeeklyUpdates.vue?vue&type=script&lang=js&"
export * from "./WeeklyUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports